import { withHTMLComponent } from '@updater-local/custom-element-v1';
import '../company-profile-content';
import '../company-profile-card';
import '../content-container';

import styles from './index.css';
import html from './index.html';

export default class CompanyProfile extends withHTMLComponent(styles, html)() {
  static props = ['value'];

  constructor() {
    super();

    this.classList.add('loading');

    this._city = this.shadowRoot.querySelector('#city');
    this._card = this.shadowRoot.querySelector(
      'upd-moveiq-company-profile-card'
    );
    this._content = this.shadowRoot.querySelector(
      'upd-moveiq-company-profile-content'
    );
  }

  updated({
    value: {
      id,
      logo,
      name,
      yearOfEstablishment,
      numberOfMoves,
      numberOfTrucks,
      rating,
      address,
      website,
      description,
      affiliations,
      noteworthy,
      services,
      coverageAreas,
    } = {},
  }) {
    if (!id) {
      this.classList.add('loading');
      return;
    }
    this.classList.remove('loading');

    this._card.value = {
      logo,
      name,
      yearOfEstablishment,
      numberOfMoves,
      numberOfTrucks,
      address,
      website,
      rating,
    };

    this._city.textContent = address.city;
    this._content.value = {
      description,
      affiliations,
      noteworthy,
      services,
      coverageAreas,
      rating,
    };
  }
}

customElements.define('upd-moveiq-company-profile', CompanyProfile);
